<template>
    <section class="content">
    <div class="box box-info">
      <!-- <div class="p-grid"> -->
        <!-- <div class="p-toolbar p-component mb-4">
          <div class="p-grid justify-content-end">
            <div class="p-col">
              <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openCounterDialog"
                  icon="pi pi-plus" label="NEW"/>
            </div>
            </div>
          
        </div> -->
      <!-- </div> -->
    
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
      <DataTable
        :value="countersList"
        :paginator="true"
        :rows="100"
        :first="0" :filters="filters"
        class="p-datatable-responsive-demo p-datatable-gridlines"
      >
        <Column header="S.N">
          <template #body="sl">
            {{sl.index+1}}
          </template>
        </Column>
        <Column field="customerName" :sortable="true" header="Name" filterMatchMode="contains">
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['customerName']"/>
          </template>
        </Column>
  
        <Column field="contact" header="Contact" :sortable="true" filterMatchMode="contains">
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['contact']"/>
          </template>
        </Column>

        <Column header="Address" field="address" filterMatchMode="contains" :sortable="true">
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['address']"/>
          </template>
        </Column>

        <Column header="Email" field="email" filterMatchMode="contains" :sortable="true">
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['email']"/>
          </template>
        </Column>
  
        <Column header="Reward Point" field="rewardPoint" filterMatchMode="contains" :sortable="true">
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['rewardPoint']"/>
          </template>
        </Column>
  
         <Column header="Total Sales" field="totalsales" filterMatchMode="contains" :sortable="true">
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['totalsales']"/>
          </template>
        </Column>
  
        <!-- <Column header="Action" >
          <template #empty>No record found</template>
          <template #body="slotProps">
            <Button type="button" icon="pi pi-pencil" class="p-button-success p-button-sm"
                    @click="editCounter(slotProps.data)"/>
            <Button icon="pi pi-trash" class="p-button-danger p-button-sm"
                    @click="openDeleteDialog(slotProps.data.id)"/>
          </template>
        </Column> -->
      </DataTable>
      </div>
 
    </div>
      <DeleteDialog v-model="showDeleteDialog" @cancel="closeDeleteDialog" @deleted="deleteCounter"/>
    </div>
  </section>
  </template>
  <script>
  import DataTable from 'primevue/datatable'
  import Dropdown from 'primevue/dropdown'
  import Column from 'primevue/column'
  import Button from 'primevue/button'
  import InputText from 'primevue/inputtext'
  import Checkbox from 'primevue/checkbox'
  import InputNumber from 'primevue/inputnumber'
  import Dialog from 'primevue/dialog'
  
  export default {
    name: 'CounterSetup',
    data() {
      return {
        showCounterDialog: false,
        editing: false,
        filters: {}
      }
    },
    mounted() {
      this.listOfCustomer()
    },
    computed: {
      posCustomerList() {
        return this.$store.state.pos.posCustomerLists
      }
    },
    methods: {
      async listOfCustomer() {
        await this.$store.dispatch('loadPosCustomerList')
      }
    },
    components: {
      DataTable,
      Column,
      Button,
      InputText,
      Checkbox,
      Dialog,
      InputNumber,
      Dropdown
    }
  }
  </script>
  <style scoped>
  </style>



// WEBPACK FOOTER //
// posCustomerReport.vue?4d118190